import DealerError from './DealerError.js'

export class DealerServiceDealerError extends DealerError {}
